import axios from "axios";

export const baseURL = "https://aydf-me.co.za:3000";
export const cableBaseURL = "wss://aydf-me.co.za:3000/cable";
export const isValidNumber = /^[0-9]+$/i;
export const isValidNumberWithForwardSlash = /^[0-9/]+$/i;

axios.defaults.baseURL = baseURL;
